import * as React from 'react'
import { Query } from 'react-apollo'

import { TargetType } from '../types'
import Content from './Content'
import ContentLoader from './ContentLoader'
import {
  EXTERNAL_SCHOOL_MAP_CALLOUT_QUERY,
  ExternalSchoolMapCallout,
  ExternalSchoolMapCalloutVariables,
} from './gql'

interface IProps {
  externalSchoolId: number
}

export default function SchoolContent(props: IProps) {
  const { externalSchoolId } = props

  return (
    <Query<ExternalSchoolMapCallout, ExternalSchoolMapCalloutVariables>
      query={EXTERNAL_SCHOOL_MAP_CALLOUT_QUERY}
      variables={{ externalSchoolId }}
    >
      {({ loading, error, data }) => {
        if (loading || error || !data || !data.externalSchool) {
          return <ContentLoader />
        }

        return (
          <Content
            target={{
              _type: TargetType.ExternalSchool,
              externalSchool: data.externalSchool,
            }}
          />
        )
      }}
    </Query>
  )
}
